// tidio-widget.js - 正式版
// 功能说明：
// 1. 自定义聊天按钮（气泡+图标）
// 2. 防止重复加载官方 Tidio 脚本
// 3. 隐藏官方默认启动器
// 4. 点击按钮首次即可打开聊天
// 5. 支持 Dawn 主题动态 Section 刷新

(function () {
  if (window.__TIDIO_WIDGET_INITIALIZED__) return;
  window.__TIDIO_WIDGET_INITIALIZED__ = true;

  // 移除残留官方启动器带 extensionVersion 的脚本
  document.querySelectorAll('script[src*="tidio.co"][src*="extensionVersion"]').forEach(s => s.remove());

  // 加载官方 Tidio 脚本
  function loadTidioScript(callback) {
    if (window.__TIDIO_SCRIPT_LOADED__) {
      if (callback) callback();
      return;
    }
    window.tidioSettings = { hideDefaultLauncher: true }; // 隐藏默认启动器
    const s = document.createElement('script');
    s.src = 'https://code.tidio.co/b7fvboanrfbjyqjaqzbtcugfs3gj3pw6.js';
    s.async = true;
    s.onload = callback;
    document.body.appendChild(s);
    window.__TIDIO_SCRIPT_LOADED__ = true;
  }

  function isTidioReady() {
    return typeof window.tidioChatApi !== 'undefined' &&
           typeof window.tidioChatApi.open === 'function';
  }

function createCustomButton() {
  if (document.getElementById('tidio-button')) return;

  const tidioBtn = document.createElement('div');
  tidioBtn.id = 'tidio-button';
  tidioBtn.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-family: Arial, sans-serif;
  `;

  const bubble = document.createElement('div');
  bubble.style.cssText = `
    background-color: #000;
    color: #fff;
    padding: 8px 12px;
    border-radius: 24px;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.25);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    white-space: nowrap;
  `;

  const icon = document.createElement('span');
  icon.textContent = '💬';
  icon.style.cssText = `
    display: inline-flex;
    align-items: center;
    justify-content: center;
  `;

  const text = document.createElement('span');
  text.textContent = 'Chat';

  bubble.appendChild(icon);
  bubble.appendChild(text);
  tidioBtn.appendChild(bubble);
  document.body.appendChild(tidioBtn);

  tidioBtn.addEventListener('mouseenter', () => {
    bubble.style.transform = 'translateY(-2px)';
    bubble.style.boxShadow = '0 4px 12px rgba(0,0,0,0.35)';
  });
  tidioBtn.addEventListener('mouseleave', () => {
    bubble.style.transform = 'translateY(0)';
    bubble.style.boxShadow = '0 2px 6px rgba(0,0,0,0.25)';
  });

  tidioBtn.addEventListener('click', () => {
    loadTidioScript(() => {
      const checkReady = setInterval(() => {
        if (isTidioReady()) {
          clearInterval(checkReady);
          window.tidioChatApi.open();
        }
      }, 100);
    });
    tidioBtn.style.display = 'none';
  });
}


  function initTidioButton() {
    createCustomButton();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initTidioButton();
  } else {
    document.addEventListener('DOMContentLoaded', initTidioButton);
  }

  // Dawn 主题 Section 动态加载支持
  document.addEventListener('shopify:section:load', initTidioButton);

})();